var $archive;
var $data;
var archive = {};

function init() {

	$archive = $('.news-archive');

	if (!$archive.length) {
		return;
	}

	$('.news-archive__year-toggle').on('click', (event) => {
		toggle($(event.currentTarget).data('id'));
	});

}

function show(id) {

	const $target = $(`.news-archive__year-items[data-id="${id}"]`);
	const $trigger = $(`.news-archive__year-toggle[data-id="${id}"]`);

	$trigger.removeClass('is--hidden');

	$target.stop().slideDown(200, () => { $target.removeAttr('style'); });
	window.setTimeout(() => { $target.removeClass('is--hidden'); }, 0);

}

function close(id) {

	const $target = $(`.news-archive__year-items[data-id="${id}"]`);
	const $trigger = $(`.news-archive__year-toggle[data-id="${id}"]`);

	$trigger.addClass('is--hidden');

	$target.stop().css({ display: 'block' }).slideUp(200, () => { $target.removeAttr('style'); });
	window.setTimeout(() => { $target.addClass('is--hidden'); }, 0);

}

function toggle(id) {

	const $target = $(`.news-archive__year-items[data-id="${id}"]`);

	if ($target.hasClass('is--hidden')) {
		show(id);
	} else {
		close(id);
	}

}

export default {
	init
};
